export const getResizeGridMetrics = ({
	divertedElement,
	defaultDivWidth,
	defaultDivHeight,
}) => {
	const styleOfDiverted = document.defaultView.getComputedStyle(divertedElement);
	const gap = parseInt(styleOfDiverted.gap) || 0;

	return {
		gap,
		gridColumnSize: defaultDivWidth + gap,
		gridRowSize: defaultDivHeight + gap,
	};
};

export const getSnappedWaterNetworkResizeSize = ({
	left,
	top,
	width,
	height,
	widgetBeingResized,
	dashboardWidgets,
	getWidgetRectPx,
	metrics,
	id,
	snapWaterNetworkResizeRect,
}) => {
	const snappedResizeRect = snapWaterNetworkResizeRect(
		{
			left,
			top,
			width,
			height,
		},
		widgetBeingResized,
		dashboardWidgets,
		getWidgetRectPx,
		metrics,
		id,
	);

	return {
		width: snappedResizeRect.width,
		height: snappedResizeRect.height,
	};
};

export const applyResizedWidgetRect = ({
	widgets,
	id,
	rect,
	serializeRectForStorage,
}) => (
	(widgets || []).map((widget) => widget.id === id ? {
		...widget,
		...serializeRectForStorage(rect),
	} : widget)
);
